import axios from "axios";
import { endpoints } from "../config/api";
import axiosErrorHandler from "./axiosHelpers";
import { axiosInstance } from "./utilities";

export const vcmProposalList = async (params, activeTabName) => {
  

  const request = await axiosInstance
    .get(
      activeTabName == "Conditional Approval"
        ? endpoints.cog.VCM_CCNDITIONAL_List
        : endpoints.cog.VCM_PROPOSAL_LIST,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const GetAddenumList = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.cog.GET_ADDENDUM,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};


export const updatePO = async (body,id) => {
  const request = await axiosInstance
    .put(
      `${endpoints.cog.PO_UPDATE}?id=${id}`,

      body
    )
    .catch(axiosErrorHandler);
  return request;
};

export const ApproveDenyAddenum = async (params, id) => {
  const request = await axiosInstance
    .put(
      `${endpoints.cog.APPROVE_DENY_ADDENDUM}?contractId=${id}`,

      { ...params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const vcmViewProposal = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.cog.VIEW_PROPOSAL,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const vcmViewAddendum = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.areaManagerProposals.AREAMANAGER_GET_CONTRACT,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};
export const viewCounterProposal = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.cog.COUNTER_PROPOSAL,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const documentVerification = async (body, params) => {
  const request = await axiosInstance
    .put(
      endpoints.cog.DOCUMENT_STATUS,

      body,
      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const approveCog = async (body, params) => {
  const request = await axiosInstance
    .post(
      endpoints.cog.APPROVE_COG,

      body,
      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const RejectCog = async (body, params) => {
  const request = await axiosInstance
    .post(
      endpoints.cog.REJECT_CONTENT_APPROVE,

      body,
      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};




export const updateProposal = async (body, params) => {
  const request = await axiosInstance
    .put(
      endpoints.cog.UPDATE_PROPOSALS,

      body,
      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const getProposalById = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.cog.GET_PROPOSAL_BY_ID,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const createBidding = async (body) => {
  const request = await axiosInstance
    .post(
      endpoints.cog.CREATE_BIDDING,
      body
    )
    .catch(axiosErrorHandler);
  return request;
};

export const BiddingListAPi = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.cog.LIST_BIDDING,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const BiddingListStorage = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.cog.LIST_BIDDING_STORAGE,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const getBiddingAPi = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.cog.GET_BIDDING,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const getBidDetailsAPi = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.cog.GET_BIDDING,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const getBidHistory = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.cog.GET_BID_HISTORY,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};
export const GetComparativeMatchrequest = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.cog.LIST_COMPARATIVE_MATCH_REQUEST,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const GetComparativeFINILIZED = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.cog.LIST_COMPARATIVE_FINILIAZED,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const getComparitivesheetShare = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.cog.LIST_COMPARATIVE_SHEET,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const newPurchaseListAPi = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.cog.LIST_NEW_PURCHASE_REQUEST,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const GetComparativeList = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.cog.LIST_COMPARATIVE_SHEET,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const GetBidDetails = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.cog.LIST_BID_DETAILS,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const sendReminderInprogress = async (params) => {
  const request = await axiosInstance
    .post(`${endpoints.cog.REMIND_TO_SUBMIT_BID}?id=${params}`)
    .catch(axiosErrorHandler);
  return request;
};

export const sendPurchaseConfirmationRequest = async (params) => {
  const request = await axiosInstance
    .post(`${endpoints.cog.REQUEST_TO_PURCHASE_CONFIRM}?id=${params}`)
    .catch(axiosErrorHandler);
  return request;
};

export const sendReminder = async (body) => {
  const request = await axiosInstance
    .post(
      endpoints.cog.SEND_REMINDER,

      body
    )
    .catch(axiosErrorHandler);
  return request;
};

export const remindToSubmitBid = async (params, body) => {
  const request = await axiosInstance
    .post(
      `${endpoints.cog.REMIND_TO_SUBMIT_BID}?id=${params}`,

      body
    )
    .catch(axiosErrorHandler);
  return request;
};

export const contractUpdate = async (body, params) => {
  const request = await axiosInstance
    .put(
      endpoints.cog.CONTRACT_UPDATE,

      body,
      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const getSupplierByPurchase = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.cog.SUPPLIER_BY_PURCHASE,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const finalizedSupplier = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.cog.FINALIZED_SUPPLIER,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

// export const getRevisedProposal = async (params) => {
//   const request = await axios({
//     method: "get",
//     url: endpoints.cog.REVISED_PROPOSAL,
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem("token")}`,
//     },
//     params,
//   }).catch(axiosErrorHandler);
//   return request;
// };

export const getRevisedProposal = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.cog.REVISED_PROPOSAL,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};
export const getDepositUpdatesList = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.cog.LIST_DEPOSIT_UPDATES,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const getDepositUpdatesStorage = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.cog.LIST_DEPOSIT_UPDATES_STORAGE,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const getDepositUpdatesById = async (params) => {
  
  const request = await axiosInstance
    .get(
      endpoints.cog.GET_DEPOSIT_UPDATES,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const deleteDepositUpdates = async (params) => {
  
  const request = await axiosInstance
    .delete(
      endpoints.cog.DELETE_DEPOSIT_UPDATES,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const editDepositUpdate = async (body, params) => {
  const request = await axiosInstance
    .put(
      endpoints.cog.EDIT_DEPOSIT_UPDATES,

      body,
      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const getCogApprovedProposal = async (params) => {
  const request = await axiosInstance
    .get(endpoints.cog.COG_APPROVED_PROPOSALS, { params })
    .catch(axiosErrorHandler);
  return request;
};

export const getAgreementUpdates = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.cog.AGREEMENT_FLOW_LIST,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};
export const getAgreementClauseUpdates = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.cog.AGREEMENT_CLAUSE_LIST,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const getClauseById = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.cog.GET_AGREEMENT_CLAUSE_BY_ID,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const getCCmember = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.cog.ADD_CC_MEMBER,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};



export const approveCCmember = async (body, params) => {
  const request = await axiosInstance
    .post(
      endpoints.cog.POST_COG_APPROVAL_CCMEMBER,

      body,
      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const contentApprovedData = async (body, params) => {
  const request = await axiosInstance
    .post(
      endpoints.cog.CONTENT_APPROVE,

      body,
      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};


export const getDownloadExcel = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.cog.DOWNLOAD_EXCEL,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};




export const rejectAgreement = async (body, params) => {
  const request = await axiosInstance
    .put(
      endpoints.cog.REJECT_AGREEMENT,

      body,
      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const updateDocument = async (body, params) => {
  const request = await axiosInstance
    .put(
      endpoints.cog.DOCUMENT_STATUS,
      body,
      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

